import { isPlantNewEwoFeatures } from 'src/utils/plantFeature';
import axios from 'src/utils/terotechDataservice';

function getTags() {
  return axios.get('/doctag/items');
}
function getTags2(pageIndex, pageSize, sorting) {
  if (sorting == undefined || sorting == '') {
    sorting = 'datecreation desc';
  }
  if (pageIndex == undefined) {
    pageIndex = 0;
  }
  if (pageSize == undefined) {
    pageSize = 1000;
  }
  const filterObj = JSON.stringify({ State: '4,1,3,0', Onhold: true });
  return axios.get(
    `/doctag/itemsv2?pageIndex=${pageIndex}&pageSize=${pageSize}&filter=${encodeURIComponent(filterObj)}&orderBy=${sorting}`
  );
}

function getApprovedTag(pageIndex, pageSize, sorting) {
  if (sorting == undefined || sorting == '') {
    sorting = 'datecreation desc';
  }
  if (pageIndex == undefined) {
    pageIndex = 0;
  }
  if (pageSize == undefined) {
    pageSize = 1000;
  }
  return axios.get(
    `/doctag/approvedItems?pageIndex=${pageIndex}&pageSize=${pageSize}&orderBy=${sorting}`
  );
}

function updateOnHold(data) {
  const options = {
    headers: { 'Content-Type': 'application/json' }
  };
  return axios.put('/doctagoperreporting/updateonhold', data, options);
}

function getTags2byId(id) {
  return axios.get(
    '/doctag/itemsById?pageIndex=0&pageSize=5&filter=%20Id%3D' +
      id +
      '&orderBy=Id%20'
  );
}

function getTagsAdvancedFiltered(
  advancedFilterData,
  pageIndex,
  pageSize,
  sorting,
  tipoRicerca,
  isSap = false,
  isSendToSap = false
) {
  const values = { ...advancedFilterData };

  if (values.DateAssignementStart == null) {
    values.DateAssignementStart = '';
  }
  if (values.DateAssignementEnd == null) {
    values.DateAssignementEnd = '';
  }
  if (values.closingDate == null) {
    values.closingDate = '';
  }
  if (values.ClosingPlannedDateStart == null) {
    values.ClosingPlannedDateStart = '';
  }
  if (values.ClosingPlannedDateEnd == null) {
    values.ClosingPlannedDateEnd = '';
  }
  if (
    values.TagId != null &&
    values.TagId !== '' &&
    (tipoRicerca == 0 || tipoRicerca == undefined)
  ) {
    tipoRicerca = 1;
  }
  if (sorting == undefined || sorting == '') {
    sorting = 'datecreation desc';
  }
  if (tipoRicerca == undefined || tipoRicerca == '') {
    tipoRicerca = 0;
  }
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const filterValues = { ...values };

  // Ensure State is an array for consistent processing
  let states = [];
  if (filterValues.State) {
    states = Array.isArray(filterValues.State) ? filterValues.State : filterValues.State.toString().split(',');
  }

  // Convert all states to strings to handle numeric values from the UI
  const stateStrings = states.map(s => s.toString());

  if (stateStrings.includes('onhold')) {
    filterValues.Onhold = true;
    states = states.filter(s => s.toString() !== 'onhold');
  }

  // Always send State as a comma-separated string to the backend
  filterValues.State = states.join(',');

  const queryString = new URLSearchParams(filterValues).toString();
  console.log('values', values);
  return axios.get(
    `/doctag/itemsByAdvancedFilters?${queryString}&pageIndex=${pageIndex}&pageSize=${pageSize}&orderBy=${sorting}&timeZone=${timeZone}&tipoRicerca=${tipoRicerca}&isSap=${isSap}&isSendToSap=${isSendToSap}`
  );
}
function getTagsFiltered(values, pageIndex, pageSize) {
  var filter = '';

  if (pageIndex == undefined) {
    pageIndex = 0;
  }

  if (pageSize == undefined) {
    pageSize = 1000;
  }

  if (values.id != null) {
    return axios.get(
      `/doctag/itemsById?pageIndex=${pageIndex}&pageSize=${pageSize}&filter=%20Id%3D${values.id}&orderBy=Id%20`
    );
  } else {
    if (values.statedoc.length == 0) {
      filter = 'Statedoc IN (5,0,4,1,3)';
    } else {
      var stateDocString = 'Statedoc IN (';
      stateDocString += values.statedoc.join(',');

      filter += stateDocString + ')';
    }
    if (
      values.dateAssignementStart != null &&
      values.dateAssignementEnd != null
    ) {
      return axios.get(
        `/doctag/itemsByDateAssignment?filter=${filter}&data1=${values.dateAssignementStart}&data2=${values.dateAssignementEnd}&pageIndex=${pageIndex}&pageSize=${pageSize}`
      );
    }
    if (values.tagDateStart != null && values.tagDateEnd != null) {
      return axios.get(
        `/doctag/itemsByDateCreation?filter=${filter}&data1=${values.tagDateStart}&data2=${values.tagDateEnd}&pageIndex=${pageIndex}&pageSize=${pageSize}`
      );
    }

    // }else{
    //   if(Data.dateAssignementStart != null && Data.dateAssignementEnd != null){
    //     return axios.get('/doctag/itemsByDateAssignement?data1='+Data.tagDateStart+'&data2='+Data.tagDateEnd)
    //   }
    //   if(Data.tagDateStart != null && Data.tagDateEnd != null){
    //     return axios.get('/doctag/itemsByDateCreation?data1='+Data.tagDateStart+'&data2='+Data.tagDateEnd)
    //   }
    // }
  }
}

function getTag(id, language) {
  if (language == undefined || !language) {
    language = 'it-IT';
  }
  return axios.get(`/doctag/items/${id}?language=${language}`);
}

function getExcelReport(
  pidPlant,
  myTimeZone,
  Date1,
  Date2,
  DateStartTag,
  DateEndTag,
  isHistory,
  isCroix = false
) {
  // return axios.get('/doctag/excelItems/' + pidPlant , {responseType: 'blob'});
  isHistory = isHistory ?? 0;
  return axios.get(
    '/doctag/excelItems?idplant=' +
      pidPlant +
      '&locTimeZone=' +
      myTimeZone +
      '&dataTagStart=' +
      DateStartTag +
      '&dataTagEnd=' +
      DateEndTag +
      '&dataTagAssStart=' +
      Date1 +
      '&dataTagAssEnd=' +
      Date2 +
      '&isHistory=' +
      isHistory +
      '&isCroix=' +
      isCroix,
    { responseType: 'blob' }
  );
}

function getNewExcelAssReport(Date1, Date2, DateStartTag, DateEndTag) {
  if (DateStartTag == null) {
    DateStartTag = '';
  }
  if (DateEndTag == null) {
    DateEndTag = '';
  }
  if (Date1 == null) {
    Date1 = '';
  }
  if (Date2 == null) {
    Date2 = '';
  }
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return axios.get(
    '/doctag/getNewTagAssExcel?' +
      'dataTagStart=' +
      DateStartTag +
      '&dataTagEnd=' +
      DateEndTag +
      '&dataTagAssStart=' +
      Date1 +
      '&dataTagAssEnd=' +
      Date2 +
      '&timeZone=' +
      timeZone,
    { responseType: 'blob' }
  );
}

function getTagSpareReporting(id) {
  return axios.get('/doctagsparereporting/items/' + id);
}

function getOperators(idteam) {
  return axios.get('/maintteam/items/' + idteam);
}

function postTag(data) {
  const options = {
    headers: { 'Content-Type': 'application/json' }
  };
  return axios.post('/doctag/items', data, options);
}

function postFile(id, files) {
  let formData = new FormData();
  files.forEach(file => {
    formData.append('file', file, file.name);
  });
  const options = {
    headers: { 'Content-Type': 'multipart/form-data' }
  };
  return axios.post(`/doctag/postFile?id=${id}`, formData, options);
}

function postTagAttachments(id, files) {
  let formData = new FormData();
  for (var i = 0; i < files.length; i++) {
    formData.append('files', files[i]);
  }
  const options = {
    headers: { 'Content-Type': 'multipart/from-data' }
  };
  return axios.post(`/doctag/postTagAttachments?id=${id}`, formData, options);
}

function putFile(id, files) {
  let formData = new FormData();
  files.forEach(file => {
    formData.append('file', file, file.name);
  });
  const options = {
    headers: { 'Content-Type': 'multipart/form-data' }
  };
  return axios.put(`/doctag/putFile?id=${id}`, formData, options);
}

function putTagAttachments(id, files) {
  let formData = new FormData();
  for (var i = 0; i < files.length; i++) {
    formData.append('files', files[i]);
  }
  const options = {
    headers: { 'Content-Type': 'multipart/from-data' }
  };
  return axios.put(`/doctag/putTagAttachments?id=${id}`, formData, options);
}

function putTag(data) {
  const options = {
    headers: { 'Content-Type': 'application/json' }
  };
  return axios.put('/doctag/items', data, options);
}

function putTagSupplierCosts(id, data) {
  const options = {
    headers: { 'Content-Type': 'application/json' }
  };
  return axios.put(`/doctag/supplier-costs/${id}`, { ...data, idTag: id }, options);
}

function getTagSupplierCostDetails(id) {
  return axios.get(`/doctag/supplier-costs/${id}/details`);
}

function putTagSupplierCostDetails(id, data) {
  const options = {
    headers: { 'Content-Type': 'application/json' }
  };
  return axios.put(
    `/doctag/supplier-costs/${id}/details`,
    { idRecord: id, ...data },
    options
  );
}

function putImages(id, images) {
  var formData = new FormData();
  images.forEach(image => {
    formData.append('images', image, image.name);
  });
  const options = {
    headers: { 'Content-Type': 'multipart/form-data' }
  };
  return axios.put('/doctagoperreporting/image?id=' + id, formData, options);
}

function putFiles(id, files) {
  var formData = new FormData();
  files.forEach(file => {
    formData.append('files', file, file.name);
  });
  const options = {
    headers: { 'Content-Type': 'multipart/form-data' }
  };
  return axios.put('/doctagoperreporting/file?id=' + id, formData, options);
}

function assignTagOperator(data) {
  const options = {
    headers: { 'Content-Type': 'application/json' }
  };
  return axios.put(`/doctag/assignTagOperator`, data, options);
}

function ReopenTag(data) {
  const options = {
    headers: { 'Content-Type': 'application/json' }
  };
  return axios.put('/doctag/Reopenitems', data, options);
}

function deleteTag(id) {
  return axios.delete('/doctag/items/' + id);
}

function getTagAnomalies() {
  //idmachine= 1 e level=1
  return axios.get(
    '/doctaganomalies/items?filter=%20Id%3E0%20&orderBy=Id%20&pageSize=1000'
  );
}
//team
function getTeams() {
  return axios.get('/maintteam/getAllTeams');
}

//rendicontazione

function getTagOperReporting(idTag) {
  return axios.get('/doctagoperreporting/itemsByTagId/' + idTag);
}

function postTagReporting(data) {
  const options = {
    headers: { 'Content-Type': 'application/json' }
  };
  return axios.post('/doctagoperreporting/items', data, options);
}

function getImages(id) {
  return axios.get('/doctagoperreporting/items/' + id);
}

//rendicontazione
function putTagReporting(data) {
  const options = {
    headers: { 'Content-Type': 'application/json' }
  };
  return axios.put('/doctagoperreporting/items', data, options);
}

function postTagSpare(data) {
  const options = {
    headers: { 'Content-Type': 'application/json' }
  };
  return axios.post('/doctagsparereporting/items', data, options);
}

function putTagSpare(data) {
  const options = {
    headers: { 'Content-Type': 'application/json' }
  };
  return axios.put('/doctagsparereporting/items', data, options);
}

function postTagSpareTool(data) {
  const options = {
    headers: { 'Content-Type': 'application/json' }
  };
  return axios.post('/doctagtoolreporting/items', data, options);
}

function putTagSpareTool(data) {
  const options = {
    headers: { 'Content-Type': 'application/json' }
  };
  return axios.put('/doctagtoolreporting/items', data, options);
}

function getTags2ByDateCreation(data1, data2) {
  return axios.get(
    '/doctag/itemsByDateCreation?data1=' + data1 + '&data2=' + data2
  );
}

function getTags2ByDateAssignement(data1, data2) {
  return axios.get(
    '/doctag/itemsByDateAssignement?data1=' + data1 + '&data2=' + data2
  );
}

//tag ASSEGNATI FILTRATI PER TEAM
function getTagAssigned(idteam, risorse, userid, plantdesc = null) {
  let filter = '';

  if (!risorse) {
    filter = 'idteam%3D ' + idteam + ' %26dateclosing%3Dnull';
  } else {
    filter = 'userOperatorAssignedId%3D ' + userid + ' %26dateclosing%3Dnull';
  }

  // Aggiungo isApproved solo se plantdesc === 'zedelgem'
  if (isPlantNewEwoFeatures(plantdesc)) {
    filter += '%26isApproved==true';
  }

  return axios.get(`/doctag/itemsv2manut?filter=${filter}`);
}

function getTagAssignedClosed(pageIndex, pageSize, sorting, idteam) {
  if (sorting == undefined || sorting == '') {
    sorting = 'datecreation desc';
  }
  if (pageIndex == undefined) {
    pageIndex = 0;
  }
  if (pageSize == undefined) {
    pageSize = 1000;
  }
  let filter;
  if (!idteam) {
    filter = `Statedoc = 5`;
  } else {
    filter = `Statedoc IN (5) AND idteam=${idteam}`;
  }
  return axios.get(
    `/doctag/itemsv2?pageIndex=${pageIndex}&pageSize=${pageSize}&filter=${encodeURIComponent(
      filter
    )}&orderBy=${sorting}`
  );
}

function getTagsAdvancedFilteredClosed(
  advancedFilterData,
  pageIndex,
  pageSize,
  sorting,
  tipoRicerca
) {
  const values = { ...advancedFilterData };

  if (values.DateAssignementStart == null) {
    values.DateAssignementStart = '';
  }
  if (values.DateAssignementEnd == null) {
    values.DateAssignementEnd = '';
  }
  if (values.closingDate == null) {
    values.closingDate = '';
  }
  if (values.ClosingPlannedDateStart == null) {
    values.ClosingPlannedDateStart = '';
  }
  if (values.ClosingPlannedDateEnd == null) {
    values.ClosingPlannedDateEnd = '';
  }
  if (
    values.TagId != null &&
    values.TagId !== '' &&
    (tipoRicerca == 0 || tipoRicerca == undefined)
  ) {
    tipoRicerca = 1;
  }
  if (sorting == undefined || sorting == '') {
    sorting = 'datecreation desc';
  }
  if (tipoRicerca == undefined || tipoRicerca == '') {
    tipoRicerca = 0;
  }
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const queryString = new URLSearchParams(values).toString();
  return axios.get(
    `/doctag/itemsByAdvancedFilters?${queryString}&pageIndex=${pageIndex}&pageSize=${pageSize}&orderBy=${sorting}&timeZone=${timeZone}&tipoRicerca=${tipoRicerca}`
  );
}

//tag CREATE FILTRATE PER UTENTE

function getTagAssignedByIduser(idPlant, idUser) {
  return axios.get(
    'doctag/itemsv2manut?filter=idPlant%3D' +
      idPlant +
      '%26idrespcreation%3D' +
      idUser
  );
}

function updateCostTypeValue(idTag, costTypeId) {
  console.log('COSTtypeid: ', costTypeId);
  return axios.put(
    `/doctag/updateCostTypeValue?idTag=${idTag}&costTypeId=${costTypeId}`
  );
}

function getNewExcelHistoryReport(Date1, Date2, DateStartTag, DateEndTag) {
  if (DateStartTag == null) {
    DateStartTag = '';
  }
  if (DateEndTag == null) {
    DateEndTag = '';
  }
  if (Date1 == null) {
    Date1 = '';
  }
  if (Date2 == null) {
    Date2 = '';
  }
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return axios.get(
    '/docTag/getNewTagHistoryExcel?' +
      'dataTagStart=' +
      DateStartTag +
      '&dataTagEnd=' +
      DateEndTag +
      '&dataTagAssStart=' +
      Date1 +
      '&dataTagAssEnd=' +
      Date2 +
      '&timeZone=' +
      timeZone,
    { responseType: 'blob' }
  );
}

function getTagPdfReport(data) {
  const options = {
    headers: { 'Content-Type': 'application/json' },
    responseType: 'blob'
  };
  return axios.post('/doctag/getLmraPdfReport', data, options);
}

function getLmraTestTag() {
  return axios.get(`/doctag/getLmraTestTag`, { responseType: 'blob' });
}

export {
  getTagsAdvancedFiltered,
  getTags,
  putTag,
  putTagSupplierCosts,
  getTagSupplierCostDetails,
  putTagSupplierCostDetails,
  getTeams,
  postTag,
  getTagAnomalies,
  getTagAssigned,
  getTag,
  postTagReporting,
  getOperators,
  putImages,
  putFiles,
  postTagSpare,
  postTagSpareTool,
  putTagReporting,
  getTagOperReporting,
  getTags2,
  putTagSpare,
  getTagSpareReporting,
  putTagSpareTool,
  getImages,
  getTags2byId,
  updateOnHold,
  getTags2ByDateCreation,
  getTags2ByDateAssignement,
  getTagAssignedByIduser,
  getTagsFiltered,
  deleteTag,
  ReopenTag,
  getExcelReport,
  getNewExcelAssReport,
  getTagAssignedClosed,
  assignTagOperator,
  postFile,
  postTagAttachments,
  putFile,
  putTagAttachments,
  updateCostTypeValue,
  getNewExcelHistoryReport,
  getTagPdfReport,
  getApprovedTag,
  getLmraTestTag
};
